import React, { Component } from  'react';

import { debounce } from 'vega';
import { drawVis } from "./util";
import { copy, objEqual } from "../js/util";
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome'
import { faPlusCircle, faTrashAlt } from '@fortawesome/free-solid-svg-icons'
import './css/SequenceView.css';
import { Button, ButtonGroup, DropdownButton, Dropdown} from 'react-bootstrap'



class SequenceView extends Component {
  constructor(props){
    super(props);
    this.state = {
      visDrawers: {}
    }

  }

  render() {
    const sequence = this.props.sequence;
    const arr = new Array(Math.max(sequence.length * 2 - 1, 0)).fill("");

    return <div className={`sequence-container border-top`} >
        {
          arr.map((_, i) => {
            let j = Math.floor(i/2);

            let classNames = ["seqBox"];
            if ((i % 2) === 0) {
              classNames = classNames.concat(["seqChart", "d-flex"]);
              if (this.props.currAnimId === j || this.props.currAnimId === j-1) {
                classNames.push("selected mouse-over");
              }
              return <div
                className={classNames.join(" ")}
                id={`seqChart${j}`}
                key={`seqBox${i}`}
                onMouseMove={(event) => this.onMouseMoveSeqChart.bind(this)(event, j)}
                onClick={(event) => this.onClickSeqChart.bind(this)(event, j)}
                onMouseLeave={(event) => this.onMouseLeaveSeqBox.bind(this)(event, j)}
                >
                  <div id={`chart${j}`}  className={"seqChart-container"}> </div>
              </div>
            } else {

              if (this.props.currAnimId === j) {
                classNames.push("selected mouse-over");
              }

              return <div
                className={classNames.concat([`seqAnim`, "text-center"]).join(" ")} id={`anim${j}`}
                onMouseMove={(event) => this.onMouseMoveSeqBoxControl.bind(this)(event, j)}
                onClick={(event) => this.onClickSeqBoxControl.bind(this)(event, j)}
                onMouseLeave={(event) => this.onMouseLeaveSeqBox.bind(this)(event, j)}
                key={`seqBox${i}`}>

                  <ButtonGroup >
                    <Button
                      placeholder="Add"
                      variant="primary"

                      id={`delete-btn-group${j}`}
                      className={"delete-btn-group"}
                      size="sm"
                      onClick={ async (event) => this.onAddChartClick(event, j)}
                    >
                      <Icon icon={faPlusCircle}></Icon>

                    </Button>

                    <DropdownButton
                      as={ButtonGroup}
                      placeholder="Delete"
                      variant="danger"
                      title={<Icon icon={faTrashAlt}></Icon>}
                      id={`delete-btn-group${j}`}
                      className={"delete-btn-group"}
                      size="sm"
                      disabled={this.props.sequence.length<=2}
                      onSelect={async (eventKey, event) => this.onRemoveChartClick(event, eventKey, j)}
                    >
                      <Dropdown.Item eventKey="prev">Previous</Dropdown.Item>
                      <Dropdown.Item eventKey="next">Next</Dropdown.Item>
                    </DropdownButton>

                  </ButtonGroup>



              </div>
            }

          })
        }
      </div>

  }
  async onRemoveChartClick(event, which, i) {
    let id = (which === "prev") ? i : i + 1;
    let newSequence = [...this.props.sequence];
    newSequence.splice(id, 1);

    let newAnimationSpecs = [...this.props.animationSpecs];
    if (id === this.props.sequence.length-1) {
      newAnimationSpecs.splice(id-1, 1);
    } else {
      newAnimationSpecs.splice(id, 1);
    }
    await this.props.onChangeSequence(newSequence, newAnimationSpecs);
  }
  onClickSeqChart(event, j) {
    let seqChart = event.target.closest(".seqChart");
    let domRect = seqChart.getBoundingClientRect();

    let id = j;
    if (j ===this.props.sequence.length-1) {
      id = j-1
    } else if(j===0){
      id = 0
    } else if ((event.clientY - domRect.y) > domRect.height/2) {
      id = j
    } else {
      id = j-1;
    }

    this.viewTransition(id)


  }
  onMouseMoveSeqChart(event, j) {
    let seqChart = event.target.closest(".seqChart");
    let domRect = seqChart.getBoundingClientRect();
    let adjacentSeqCharts = this.getAdjacentSeqCharts(seqChart, j);
    let animSeqBox;

    this.highlightSeqBox(seqChart, "mouse-over", true)


    if (!adjacentSeqCharts.next || !adjacentSeqCharts.prev) {
      animSeqBox = this.getAnimSeqBox(j);
      this.highlightSeqBox(animSeqBox, "mouse-over", true)
      this.highlightSeqBox(adjacentSeqCharts.next || adjacentSeqCharts.prev, "mouse-over", true)
    } else {
      if ((event.clientY - domRect.y) > domRect.height/2) {
        this.highlightSeqBox(this.getAnimSeqBox(j), "mouse-over", true)
        this.highlightSeqBox(this.getAnimSeqBox(j-1), "mouse-over", false)

        this.highlightSeqBox(adjacentSeqCharts.next, "mouse-over", true)
        this.highlightSeqBox(adjacentSeqCharts.prev, "mouse-over", false)
      } else {
        this.highlightSeqBox(this.getAnimSeqBox(j-1), "mouse-over", true)
        this.highlightSeqBox(this.getAnimSeqBox(j), "mouse-over", false)

        this.highlightSeqBox(adjacentSeqCharts.prev, "mouse-over", true)
        this.highlightSeqBox(adjacentSeqCharts.next, "mouse-over", false)
      }

    }

  }
  getAnimSeqBox(j) {
    if (j===this.props.sequence.length-1) {
      return document.getElementById(`anim${j-1}`)
    }
    return document.getElementById(`anim${j}`)
  }
  getAdjacentSeqCharts(seqChartElm, j) {

    if (j===0) {
      return {next: seqChartElm.parentElement.querySelector(`#seqChart${j+1}`)};
    } else if (j===this.props.sequence.length-1) {
      return {prev: seqChartElm.parentElement.querySelector(`#seqChart${j-1}`)};
    }

    return {
      next: seqChartElm.parentElement.querySelector(`#seqChart${j+1}`),
      prev: seqChartElm.parentElement.querySelector(`#seqChart${j-1}`)
    };

  }
  onMouseMoveSeqBoxControl(event, j) {
    let seqBox = event.target.closest(".seqBox");

    this.highlightSeqBox(document.querySelector(`#seqChart${j}`), "mouse-over", true)
    this.highlightSeqBox(document.querySelector(`#seqChart${j+1}`), "mouse-over", true)
    this.highlightSeqBox(seqBox, "mouse-over", true)
  }

  onClickSeqBoxControl(event, j) {
    let id = j;
    if (event.target.classList.contains("seqBox")) {
      this.viewTransition(id)
    }
  }


  onMouseLeaveSeqBox(event, j) {
    document.querySelectorAll(".seqBox.mouse-over").forEach(elem => {
      elem.classList.remove("mouse-over");
    })

  }
  highlightSeqBox(seqBoxElm, type, action) {
    let cssClass = type;

    if (action) {
      seqBoxElm.classList.add(cssClass)
    } else {
      seqBoxElm.classList.remove(cssClass)
    }

  }
  async onAddChartClick(event, id) {

    let newSequence = [...this.props.sequence];
    newSequence.splice(id, 0, copy(this.props.sequence[id]));

    let newAnimationSpecs = [...this.props.animationSpecs];
    newAnimationSpecs.splice(id, 0, copy(this.props.animationSpecs[id]));

    await this.props.onChangeSequence(newSequence, newAnimationSpecs);

  }
  viewTransition(id) {
    if (this.props.currAnimId === id) {
      this.props.onChangeCurrAnimId(undefined);
    } else {
      this.props.onChangeCurrAnimId(id);
    }
  }

  async componentDidUpdate(prevProps){

    const visDrawers = {...this.state.visDrawers};
    let isUpdated = false;

    for (let i = 0; i < this.props.sequence.length; i++) {
      const prevChart_i = prevProps.sequence[i];
      const currChart_i = this.props.sequence[i];



      if (!objEqual(prevChart_i, currChart_i)) {
        if (visDrawers[i]) {
          visDrawers[i](currChart_i)
        } else {
          let debounceDrawVis = this.genDebounceDrawVis(`#chart${i}`)
          debounceDrawVis(currChart_i);
          visDrawers[i] = debounceDrawVis
          isUpdated = true;
        }
      }
    }
    if (isUpdated) {
      this.setState({visDrawers})
    }

  }
  genDebounceDrawVis(target) {
    return (spec) => {
      debounce(700, async () => { await drawVis( target, spec ) })();
    }
  }
}

export default SequenceView;
